import { useTranslation } from 'react-i18next';
import List from "../../../../GlobalComponents/List/List";
import Error from "../../../../GlobalComponents/Error";
import { GetApolloErrorText } from "../../../../GlobalFunctions/helper";
import excludedIcon from '../../../../Media/Images/Icons/excluded.webp';
import InputCard from "../../../../GlobalComponents/InputCard";
import NoItems from '../../../../GlobalComponents/NoItems';
import UseGetAllCoverProducts from '../../Library/Covers/UseGelAllCoverProducts';

const ExcludedProducts = ({
    formData,
    selectedCoverID,
    lang,
    SetFormData
}) => {

    const {t} = useTranslation();

    const {
        content,
        loading,
        error,
        headerData,
        SelectRow,
        SelectAll
    } = UseGetAllCoverProducts(formData.selectedExcludedProducts,lang,selectedCoverID,SetFormData);

    return(
        <div>
            {selectedCoverID && selectedCoverID != 0 ?
                <>
                    {error ?
                        <Error text={GetApolloErrorText(error)} />
                    :
                        <>
                            <InputCard
                                title = {t("ExcludedProducts")}
                                icon = {excludedIcon}
                                noBodyPadding = {true}
                                headerInfoContent = {[
                                    t("ExcludedProductsInfo")  
                                ]}
                            > 
                                <List 
                                    headerData = {headerData} 
                                    contentData = {content}
                                    headerClassName = {"no-top-border"}
                                    isSortable = {false}
                                    loading = {loading}
                                    OnSelectAll = {(e) => SelectAll(e)}
                                    hideOptions = {true}
                                    options = {{
                                        OnSelect: (e,rowData) => SelectRow(e,rowData.rowID),
                                    }}
                                />
                            </InputCard>
                        </>
                    }

                </>
            :
                <NoItems
                    className = {"no-margin justify-content-center"}
                    text={t("ToAddChooseExcludedProductsSaveBasicInformationsFirst")} 
                />   
            }

        </div>
    )
}

export default ExcludedProducts;